import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    sell_contract_note: {
      ...jsConn.formParams,
    },
  };
};

const itemDetails = {
  pluralName: "sell_contract_notes",
  singularName: "sell_contract_note",
};

async function needSellContractNotes(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    return Promise.resolve(jsConn);
  });
}

async function createSellContractNote(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      return Promise.resolve(jsConn);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteSellContractNote(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const sellContractNotesController = {
  createSellContractNote,
  needSellContractNotes,
  deleteSellContractNote,
};
